import { inject } from '@angular/core';
import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandlerFn,
    HttpInterceptorFn,
    HttpRequest,
} from '@angular/common/http';
import { catchError, Observable } from 'rxjs';
import { TokensService } from '../services';
import { Store } from '@ngrx/store';
import { jwtDecode } from 'jwt-decode';
import { ResetCustomerAction, RemoveCustomerDataAction, ResetCustomersAction, ResetAdminAuthDataAction, ResetAuthDataAction } from '../ngrx';

export const AuthInterceptor: HttpInterceptorFn = (
    request: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
    const tokensService = inject(TokensService);
    const modifiedRequest = request.clone({
        setHeaders: tokensService.hasAccessTokenStored ? {
            Authorization: `Bearer ${tokensService.accessToken}`,
        } : {},
    });

    return next(modifiedRequest);
};

export const AuthErrorInterceptor: HttpInterceptorFn = (
    request: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<any>> => {

    const tokensService = inject(TokensService);
    const store = inject(Store);

    return next(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 && tokensService.hasAccessTokenStored) {
            if(tokenHasAdminUserRole(tokensService.accessToken)) {
                store.dispatch(ResetCustomerAction());
                store.dispatch(RemoveCustomerDataAction());
                store.dispatch(ResetCustomersAction());
                store.dispatch(ResetAdminAuthDataAction());
            } else {
                store.dispatch(ResetAuthDataAction());
            }
        }
        throw error;
      })
    );
};

const tokenHasAdminUserRole = (token: string): boolean => {
    const decodedToken: { user_roles: string[] } = jwtDecode(token);
    const roles = decodedToken?.user_roles || [];
    return roles.includes('Clicklease Admin');
}


